import React, { useState, useEffect } from "react";

import { Form, Modal, Button, Row, Col, FormControl } from "react-bootstrap";
import { extractVendorStatus } from "../../../OnboardingContainer";

import { updateServiceData } from "../../../../../redux/serviceSlice";
import { updateCommonInfo } from "../../../../../redux/commonSlice";
import * as Constants from "../../../../../constants/Constants";
import Cookie from "js-cookie";

import "./MerchantContactsModal.css";
import { useDispatch } from "react-redux";

import {
  httpGetDbmDropDownData,
  httpPostDbmSaveData,
  httpGetVendorStatusDetails,
  httpGetVendorProfileById,
} from "../../../../../service/httpClient";

import { isBloomingdalesMerchantEmail } from "../../../OnboardingHelper";

const MerchantDbmApprovalModal = ({
  open,
  handkeOkHandle,
  handkeCloseHandle,
  profileId,
  vendorDetail,
  hierarchy,
}) => {
  const dispatch = useDispatch();
  const [dbmDropDownData, setDbmDropDownData] = useState([]);
  const [selectedDbmValue, setSelectedDbmValue] = useState("");
  const [validationMesg, setValidationMesg] = useState("");
  const [gmmDropDownData, setGmmDropDownData] = useState([]);
  const [selectedGmmValue, setSelectedGmmValue] = useState("");

  const merchantEmail = vendorDetail?.merchantContact?.email || "";
  const merchandiseType = vendorDetail?.vendorDetail?.merchandiseType || "";
  const gmmSubmittedToDbVal = vendorDetail?.vendorDetail?.gmmSubmittedTo || "";

  const handleCancel = () => {
    handkeOkHandle();
  };

  const handleSave = () => {
    const data = {
      vendorProfileId: profileId,
      submittedBy: selectedDbmValue,
      lastActivity: "submittedToDBM",
      lastUpdatedBy: Cookie.get("email")
        ? Cookie.get("email").toLowerCase()
        : "",
      hierarchy,
    };

    if (displayGmmOpt(merchantEmail, merchandiseType)) {
      data["gmmSubmittedTo"] = selectedGmmValue;
    }

    httpPostDbmSaveData(data)
      .then((res) => {
        httpGetVendorProfileById(profileId)
          .then((vendorProfileRes) => {
            let vendorProfile = vendorProfileRes?.data || {};
            httpGetVendorStatusDetails(profileId)
              .then((vendorStatus) => {
                const { mutatedVendorStatus } = extractVendorStatus(
                  vendorProfile.vendorDetail.status,
                  vendorStatus.data
                );
                dispatch(updateServiceData({ vendorProfile, vendorStatus }));
                dispatch(
                  updateCommonInfo({
                    boardingStatuses: mutatedVendorStatus,
                  })
                );
                setValidationMesg("");
              })
              .catch((error) => {
                setValidationMesg(error.message);
              });
            handkeCloseHandle();
          })
          .catch((err) => {
            setValidationMesg(err.message);
            handkeCloseHandle();
          });
      })
      .catch((err) => {
        setValidationMesg(err.message);
        handkeCloseHandle();
      });
  };

  useEffect(() => {
    httpGetDbmDropDownData("divisionalBusinessManager")
      .then((res) => {
        setDbmDropDownData(res.data);
        setValidationMesg("");
      })
      .catch((err) => {
        setValidationMesg(err.message);
        setDbmDropDownData([]);
      });

    if (displayGmmOpt(merchantEmail, merchandiseType)) {
      httpGetDbmDropDownData("bdsGMM")
        .then((res) => {
          setGmmDropDownData(res.data);
          setValidationMesg("");
        })
        .catch((err) => {
          setValidationMesg(err.message);
          setGmmDropDownData([]);
        });
    }
  }, []);

  const handleSelect = (e) => {
    setSelectedDbmValue(e.target.value);
  };
  const handleGmmSelect = (e) => {
    setSelectedGmmValue(e.target.value);
  };

  const displayGmmOpt = (merchantEmail, merchandiseType) => {
    return (
      isBloomingdalesMerchantEmail(merchantEmail, merchandiseType) &&
      !gmmSubmittedToDbVal
    );
  };

  const checkDisableSubmitBtn = () => {
    let isDisabled = !selectedDbmValue;
    if (displayGmmOpt(merchantEmail, merchandiseType)) {
      isDisabled = selectedDbmValue && selectedGmmValue ? false : true;
    }
    return isDisabled;
  };

  return (
    <>
      <Modal
        contentClassName="merchantDbmModal"
        show={open}
        onHide={handkeCloseHandle}
        backdrop="static"
      >
        <Modal.Header closeButton className="merSubmitToDbmHeader">
          <Modal.Title>
            <div style={{ textAlign: "center" }}>
              {displayGmmOpt(merchantEmail, merchandiseType)
                ? Constants.MERCHANT_APPROVAL_SUBMIT_TO_DMM_GMM
                : Constants.MERCHANT_APPROVAL_SUBMIT_TO_DBM}
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="merchantContactsModalBody">
          {validationMesg && (
            <Row>
              <p className="validationErrorMsg" style={{ marginLeft: "10px" }}>
                {validationMesg}
              </p>
            </Row>
          )}
          <Row>
            <Form.Group as={Col} md={6} className="compDetailsFormLabel">
              {displayGmmOpt(merchantEmail, merchandiseType)
                ? Constants.SELECT_DMM_LABEL
                : Constants.DBM_MESSAGE}
            </Form.Group>
            <Form.Group as={Col} md={5}>
              <FormControl
                as="select"
                name="operatingDivision"
                defaultValue={Constants.SELECT_ONE}
                value={selectedDbmValue || Constants.SELECT_ONE}
                onChange={(event) => handleSelect(event)}
                disabled={false}
              >
                <option value="" selected hidden>
                  {Constants.SELECT_ONE}
                </option>
                {dbmDropDownData.map((option, oi) => (
                  <option value={option.emailId} key={oi}>
                    {option.userName}
                  </option>
                ))}
              </FormControl>
            </Form.Group>
          </Row>
          {displayGmmOpt(merchantEmail, merchandiseType) ? (
            <>
              <Row>
                <Form.Group as={Col} md={6} className="compDetailsFormLabel">
                  {Constants.SELECT_GMM_LABEL}
                </Form.Group>
                <Form.Group as={Col} md={5}>
                  <FormControl
                    as="select"
                    name="gmmSubmitTo"
                    defaultValue={Constants.SELECT_ONE}
                    value={selectedGmmValue || Constants.SELECT_ONE}
                    onChange={(event) => handleGmmSelect(event)}
                    disabled={false}
                  >
                    <option value="" selected hidden>
                      {Constants.SELECT_ONE}
                    </option>
                    {gmmDropDownData.map((option, oi) => (
                      <option value={option.emailId} key={oi}>
                        {option.userName}
                      </option>
                    ))}
                  </FormControl>
                </Form.Group>
              </Row>
              <Row className="modalNotificationMsg">
                {Constants.DMM_GMM_MESSAGE}
              </Row>
            </>
          ) : (
            ""
          )}
        </Modal.Body>
        <Modal.Footer className="merchantContactsFooter">
          <Button className="button-later-md" onClick={handleCancel}>
            {Constants.BUTTON_CANCEL}
          </Button>
          <Button
            className="button-primary-md"
            onClick={handleSave}
            disabled={checkDisableSubmitBtn()}
          >
            {Constants.BUTTON_SUBMIT}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default MerchantDbmApprovalModal;
